import { lazy, Suspense, useState } from 'react'
import { motion } from 'framer-motion'
import { ScanBarcode, Loader2, Bug } from 'lucide-react'
import { SearchBar } from './SearchBar'
import { AppGrid } from './AppGrid'
import { Button } from '@/components/ui/button'
import { captureException } from '@/lib/sentry'

// Lazy load the scanner component to avoid loading @zxing/library in main bundle
const BackgroundScanner = lazy(() => import('./BackgroundScanner'))

export function Dashboard() {
  const [showScanner, setShowScanner] = useState(false)

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="flex-1 flex flex-col justify-center w-[75vw] max-w-xl mx-auto py-6"
    >
      <div className="space-y-4">
        <SearchBar />

        {showScanner ? (
          <Suspense fallback={
            <Button variant="outline" size="lg" className="w-full h-14 text-base" disabled>
              <Loader2 className="h-5 w-5 mr-2 animate-spin" />
              Laster skanner...
            </Button>
          }>
            <BackgroundScanner onClose={() => setShowScanner(false)} />
          </Suspense>
        ) : (
          <Button
            variant="secondary"
            size="lg"
            className="w-full h-14 text-base border border-border"
            onClick={() => setShowScanner(true)}
          >
            <ScanBarcode className="h-5 w-5 mr-2" />
            Skann strekkode
          </Button>
        )}

        <AppGrid />

        {/* Dev-only test button for Sentry verification */}
        {import.meta.env.DEV && (
          <Button
            variant="ghost"
            size="sm"
            className="w-full text-muted-foreground text-xs mt-4"
            onClick={() => {
              const error = new Error('TEST: Sentry verification error')
              captureException(error, { test: true, timestamp: Date.now() })
              console.log('[Sentry Test] Error captured:', error.message)
            }}
          >
            <Bug className="h-3 w-3 mr-1" />
            Test Sentry Error
          </Button>
        )}
      </div>
    </motion.div>
  )
}
